import React from "react";
import logo from "../assets/logo.png";

const Footer = () => {
  return (
    <footer className="bg-navy text-soft-white py-8 px-4">
      <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Logo and Description */}
        <div className="flex flex-col">
          <div className="flex items-center">
            <img 
              src={logo} 
              alt="PaySub Logo" 
              className="w-16 h-16 object-contain"
            />
          </div>
          <p className="text-sm mt-4">
            Empowering you with seamless VTU services and a connected community.
          </p>
        </div>

        {/* Navigation Links */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-2">
            <li>
              <a href="#home" className="hover:text-golden-yellow">
                Home
              </a>
            </li>
            <li>
              <a href="#about" className="hover:text-golden-yellow">
                About
              </a>
            </li>
            <li>
              <a href="#features" className="hover:text-golden-yellow">
                Features
              </a>
            </li>
            <li>
              <a href="#contact" className="hover:text-golden-yellow">
                Contact
              </a>
            </li>
          </ul>
        </div>

        {/* Newsletter Signup */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Stay Updated</h3>
          <form className="flex flex-col gap-4">
            <input
              type="email"
              placeholder="Enter your email"
              className="px-4 py-2 rounded bg-light-gray text-charcoal-gray placeholder-charcoal-gray focus:outline-none"
            />
            <button
              type="submit"
              className="px-4 py-2 bg-golden-yellow text-charcoal-gray rounded hover:bg-yellow-500"
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="mt-8 border-t border-light-gray pt-4 text-center text-sm">
        <p>&copy; {new Date().getFullYear()} VTUApp. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
